// extracted by mini-css-extract-plugin
export default {"attr-display-table":"AttrDisplayTable_attr-display-table__ko5+9","p-dropdown":"AttrDisplayTable_p-dropdown__OeyUc","tooltip-icon":"AttrDisplayTable_tooltip-icon__aUJEb"};